import { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { FilledInput, Button, FormGroup, FormLabel, FormControl, Box, Grid, Collapse, TextField, Divider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import AuthContext from '../../context';
import { put } from '../../utils/api-services';
import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    buttonContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 5
    },
    storeBtn: {
        width: '100%',
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none'
        }
    }
}));

const defMaster = { id: 0, name: 'Choose a master ticket' };

const CarrierDetailAddMasterTicket = ({ open, id, masters, permissions, setMasters, onClose }) => {

    const classes = useStyles();
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const [selectedMaster, setSelectedMaster] = useState(defMaster);

    const validate = () => {
        if (Number(selectedMaster?.id) === 0) {
            showToast('Select some master ticket', 'error');
            return false;
        }

        const cond = window.confirm('Are you sure you want add this master ticket?');
        return cond;
    }

    const store = async () => {
        const cond = validate();
        if (cond) {
            showLoader(true);
            const response = await put(`/ticketCarrier/${id}/addMasterTicket`, { master: selectedMaster });
            if (response.status === 200) {
                const { message, masters, mastersToAdd } = response;
                showToast(message);
                setMasters(masters, mastersToAdd);
                onClose();
                clear();
            } else {
                console.log('[CarrierDetailAddMasterTicket] store error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const clear = () => setSelectedMaster(defMaster);

    return (
        <Collapse in={open}>
            <Divider />
            <h3>{'Add master ticket'}</h3>
            <Grid container>
                <Grid item xs={6} md={3} lg={2}>
                    <FormGroup>
                        <FormLabel>{'Master ticket'}</FormLabel>
                        <Autocomplete
                            options={masters}
                            value={selectedMaster}
                            getOptionLabel={option => option?.name ?? ''}
                            getOptionSelected={(option, value) => option.id === value.id}
                            onChange={(e, value) => setSelectedMaster(value)}
                            renderInput={(params) => <TextField {...params} placeholder='Master ticket' />}
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={6} md={3} lg={2}>
                    <FormGroup>
                        <FormLabel>{'Supplier'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                disabled
                                placeholder='Supplier'
                                value={selectedMaster?.supplier?.name ?? ''}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item xs={6} md={3} lg={2}>
                    <FormGroup>
                        <FormLabel>{'Location'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                disabled
                                placeholder='Location'
                                value={selectedMaster?.location?.name ?? ''}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>
                <Grid item xs={6} md={3} lg={2}>
                    <FormGroup>
                        <FormLabel>{'Total'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                disabled
                                placeholder='Total'
                                value={selectedMaster?.total ?? 0}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>

                <Grid item xs={6} md={2} xl={1} className={classes.buttonContainer}>
                    <Button
                        variant='contained'
                        color='secondary'
                        style={{ width: '100%' }}
                        onClick={clear}
                    >
                        {'Cancel'}
                    </Button>
                </Grid>
                {
                    (permissions.update_attr) &&
                    <Grid item xs={6} md={2} xl={1} className={classes.buttonContainer}>
                        <Button
                            variant='contained'
                            className={classes.storeBtn}
                            onClick={store}
                        >
                            {'Store'}
                        </Button>
                    </Grid>
                }
            </Grid>
        </Collapse>
    );
}

export default CarrierDetailAddMasterTicket;